import * as React from "react";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
// import FacebookIcon from "@mui/icons-material/Facebook";
// import TwitterIcon from "@mui/icons-material/Twitter";
// import InstagramIcon from "@mui/icons-material/Instagram";
// import LinkedInIcon from "@mui/icons-material/LinkedIn";
// import YouTubeIcon from "@mui/icons-material/YouTube";
// import logo from "../../image/Termovent-logo.png";
// import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import config from "../../utils/config"
//import theme from "../../styles/TermoventTheme";

function Copyright() {
  const theme = useTheme();

  // Izvlačenje poddomena
  const subdomain = window.location.hostname.split(".")[0].toLowerCase();

  // Odredi naziv firme na osnovu poddomena
  let companyName = "Termovent"; // podrazumevano
  if (subdomain.includes("clivet")) {
    companyName = "Clivet";
  } else if (subdomain.includes("prolux")) {
    companyName = "Prolux";
  }   
  return (
    <Typography
      variant="body2"
      sx={{
        color: theme.palette.primary.main,
        fontSize: "14px",
        display: "flex",
        alignItems: "center"}}>
      {config.appName} - {config.appVersion}
      {" | "}
      {"Copyright © "}
      {companyName} {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

function Footer() {
  const theme = useTheme();

  return (
    <Paper
      sx={{
        bottom: 0,
        width: "100%",
        // marginTop: "auto",
      }}
    >
      <footer
        className="footer"
        style={{
          backgroundColor: "white",
          borderTop: "1px solid #e0e0e0",
          paddingTop: "10px",
          paddingBottom: "10px",
        }}
      >
        {/* <div className="footer-left">
          <img src={logo} alt="logo" />
          <p className="footer-desc">{t("footer.description")}</p>
          <div
            className="socials"
            style={{
              display: "flex",
              // gap: "35px",
              justifyContent: "space-between",
              position: "relative",
              left: "-5px",
            }}
          >
            <a
              href="https://www.instagram.com/termovent/"
              target="_blank"
              rel="noreferrer"
            >
              <InstagramIcon
                sx={{
                  color: theme.palette.secondary.main,
                  width: "40px",
                  height: "30px",
                }}
              />
            </a>
            <a
              href="https://sr-rs.facebook.com/termovent"
              target="_blank"
              rel="noreferrer"
            >
              <FacebookIcon
                sx={{
                  color: theme.palette.secondary.main,
                  width: "40px",
                  height: "30px",
                }}
              />
            </a>
            <a
              href="https://twitter.com/termoventkomerc"
              target="_blank"
              rel="noreferrer"
            >
              <TwitterIcon
                sx={{
                  color: theme.palette.secondary.main,
                  width: "40px",
                  height: "30px",
                }}
              />
            </a>
            <a
              href="https://www.linkedin.com/company/termovent-komerc"
              target="_blank"
              rel="noreferrer"
            >
              <LinkedInIcon
                sx={{
                  color: theme.palette.secondary.main,
                  width: "40px",
                  height: "30px",
                }}
              />
            </a>
            <a
              href="https://www.youtube.com/user/termovent"
              target="_blank"
              rel="noreferrer"
            >
              <YouTubeIcon
                sx={{
                  color: theme.palette.secondary.main,
                  width: "40px",
                  height: "30px",
                }}
              />
            </a>
          </div>
        </div>
       {/* <ul className="footer-right">
          <li>
            <h2 color={theme.palette.secondary.main}>{t("footer.product")}</h2>
            <ul className="box">
              <li>
                <a
                  href="https://www.youtube.com/user/termovent"
                  rel="noreferrer"
                >
                  Frameless
                </a>
              </li>
              <li>
                <a
                  href="https://termovent.com/en/air-handling-unit/"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t("footer.airhandling")}
                </a>
              </li>
              <li>
                <a
                  href="https://termovent.com/en/clean-room/"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t("footer.clearnroom")}
                </a>
              </li>
              <li>
                <a
                  href="https://termovent.com/en/engineering/"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t("footer.enginering")}
                </a>
              </li>
            </ul>
          </li>
          <li className="features">
            <h2>{t("footer.userlinks")}</h2>
            <ul className="box">
              <li>
                <a
                  href="https://termovent.com/en/references/"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t("footer.references")}
                </a>
              </li>
              <li>
                <a
                  href="https://termovent.com/en/catalogues/"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t("footer.cataloues")}
                </a>
              </li>
            </ul>
          </li>
          <li>
            <h2>{t("footer.address")}</h2>
            <ul className="box">
              <li>
                <a
                  href="https://goo.gl/maps/pwiJn34WEV7q3gpT6"
                  target="_blank"
                  rel="noreferrer"
                >
                  Kneza Miloša 88a, Beograd, Srbija
                </a>
              </li>
              <li>
                <a
                  href="http://www.belgradeskyline.rs/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Skyline, objekat D, 1. sprat
                </a>
              </li>

              <li>
                <a href="tel:+381113087404">+381 (11) 3087 404</a>
              </li>
              <li>
                <a
                  href="mailto:info@termovent.rs"
                  target="_blank"
                  rel="noreferrer"
                >
                  info@termovent.rs
                </a>
              </li>
            </ul>
          </li>
        </ul>
        </ul>*/}
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          wrap="nowrap"
          sx={{ width: "100%", margin: 0, padding: "10px 16px", gap: "8px" }}
        >
          <Grid item xs="auto">
            <Typography
              variant="body2"
              sx={{
                color: theme.palette.primary.main,
                fontSize: "14px",
                display: "flex",
                alignItems: "center",
              }}
            >

            </Typography>
          </Grid>
          <Grid
            item
            xs="auto"
            className="footer-bottom"
            style={{ display: "flex", alignItems: "center" }}
          >
            <Copyright />
          </Grid>
        </Grid>
      </footer>
    </Paper>
  );
}

export default Footer;
